// Material UI
import { GridColDef, GridColumnHeaderParams } from "@mui/x-data-grid-premium";

// Custom components
import { TypographyCell } from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";
import CommonToolbar from "@/Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";
import NoRowsOverlay from "@/Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";
// Types
import { IGetChangeRequest } from "@/Washouts/types/PayrollClosing/queries";
import { TypographyHeader } from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyHeader";
import { HEADER_CLASS_NAME } from "@/Constants/tables";

// Constants
import { DATE_FORMAT } from "@/Constants/date";
import { getDateInUTC, getFormattedDate } from "@dealerwave/dw-layer-date-converter";

export const positionFilterItemId = "position-filter";

export const customProps = {
	tableContainerStyle: { height: "100%", width: "100%" },
	tableClassName: {
		"[&_.MuiDataGrid-row.Mui-selected]:!bg-table-hover": true,
		"[&_.MuiGridRow:hover]:bg-table-hover": true,
		"[&_.toolbar-actions]:!right-0": true,
		"[&_.MuiDataGrid-iconSeparator]:!mt-[7px]": true,
		"!top-[-10px]": true,
		"[&_.MuiDataGrid-main]:!mt-[20px]": true,
	},
	hide: false,
};

export const columnVisibilityModel = {
	_id: false,
};

export const slots = {
	toolbar: CommonToolbar,
	noRowsOverlay: NoRowsOverlay,
	noResultsOverlay: NoRowsOverlay,
};

const baseColDef: Partial<GridColDef<IGetChangeRequest & { __selected?: boolean }>> = {
	headerClassName: HEADER_CLASS_NAME,
	renderHeader: (params) => <TypographyHeader params={params as unknown as GridColumnHeaderParams} />,
	type: "string",
	resizable: false,
	renderCell: (params) => <TypographyCell params={params} />,
};

export const getBaseColumns = (timezone: string): GridColDef<IGetChangeRequest & { __selected?: boolean }>[] => [
	{
		...baseColDef,
		field: "_id",
		headerName: "ID",
		width: 10,
		filterable: false,
	},
	{
		...baseColDef,
		field: "requestTimestamp",
		headerName: "Request Date",
		type: "date",
		width: 100,
		flex: 1,
		valueGetter: (value) => value && getDateInUTC(value),
		valueFormatter: (value: Date) => getFormattedDate(value, timezone, DATE_FORMAT.fullAbbrTime12hPadded),
	},
	{
		...baseColDef,
		field: "payPeriod",
		headerName: "Pay Period",
		width: 100,
		flex: 1,
		valueGetter: (value?: { title: string }) => value?.title,
	},
	{
		...baseColDef,
		field: "createdBy",
		headerName: "Requested By",
		minWidth: 100,
		resizable: true,
		flex: 1,
		valueGetter: (value: { fullName: string }) => value?.fullName,
	},
	{
		...baseColDef,
		field: "position",
		headerName: "Position",
		minWidth: 100,
		flex: 1,
		filterable: true,
	},
	{
		...baseColDef,
		field: "issueSummary",
		headerName: "Issue Summary",
		width: 200,
		minWidth: 200,
		resizable: true,
		flex: 1,
	},
	{
		...baseColDef,
		field: "status",
		headerName: "Status",
		width: 100,
		minWidth: 100,
		flex: 1,
		valueFormatter: (value: string, row) => (row.status === "PENDING" && row.supportAssigned ? "ESCALATED" : value),
	},
	{
		...baseColDef,
		field: "resolvingUser",
		headerName: "Resolving User",
		width: 100,
		minWidth: 100,
		flex: 1,
		valueGetter: (value: { fullName: string }) => value?.fullName,
	},
	{
		...baseColDef,
		field: "resolutionTimestamp",
		headerName: "Resolution Date",
		type: "date",
		width: 100,
		minWidth: 100,
		valueGetter: (value) => value && getDateInUTC(value),
		valueFormatter: (value: Date) => getFormattedDate(value, timezone, DATE_FORMAT.fullAbbrTime12hPadded),
		flex: 1,
	},
];
